<template>
  <div>
    <v-list>
      <!-- parent item -->
      <div v-for="(item, index) in items" :key="item.id">
        <v-list-group v-if="item.completed == pageCompletionFilter" no-action>
          <template v-slot:appendIcon>
            <!-- show expand icon only if sub-tasks available  -->
            <v-icon v-if="item.sub_tasks && item.sub_tasks.length">
              mdi-chevron-down
            </v-icon>
            <!-- else show dummy icon made hidden -->
            <v-icon v-else style="visibility: hidden;">
              mdi-chevron-up
            </v-icon>
          </template>
          <template v-slot:activator>
            <v-checkbox
              v-model="item.completed"
              @click.stop="handleCheckbox(item)"
              :disabled="
                !isLoading &&
                  items &&
                  item.creator &&
                  !(currentUser.id == item.assignee.id) &&
                  !(currentUser.id == item.creator.id) &&
                  !currentUser.privileges.canCompleteAllTasks
              "
            ></v-checkbox>

            <v-list-item-content>
              <v-list-item-title
                class="wrap-text"
                @click.stop="triggerTaskDetails(item, index);handleTour();"
              >
                {{ item.title }}
              </v-list-item-title>

              <v-list-item-subtitle class="wrap-text">
                <v-icon small>
                  mdi-calendar
                </v-icon>
                <span
                  :class="
                    checkIsBefore(item.due_datetime)
                      ? 'red--text font-weight-medium'
                      : 'green--text font-weight-medium'
                  "
                >
                  {{ moment(item.due_datetime).format("DD MMM h:mm a") }}
                </span>
                <div
                  v-for="tag in item.task_tags"
                  :key="tag.id"
                  class="d-inline-block"
                >
                  <span
                    :style="
                      `color: ${tag.color}; font-weight: 500; margin: 0 3px`
                    "
                    @click.stop="applyTagFilter(tag)"
                  >
                    {{ tag.name }}
                  </span>
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-tooltip
              v-if="item.description"
              bottom
              :max-width="$vuetify.breakpoint.smAndDown ? '65%' : '30%'"
            >
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-icon class="mr-2" v-if="item.description">
                    mdi-text-box-outline
                  </v-icon>
                </div>
              </template>
              <div class="tooltip">{{ item.description }}</div>
            </v-tooltip>

            <v-tooltip bottom :disabled="showAssigneeName">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-list-item-avatar>
                    <v-img :src="item.assignee.image"></v-img>
                  </v-list-item-avatar>
                </div>
              </template>
              <span>{{ item.assignee.full_name }}</span>
            </v-tooltip>

            <v-list-item-action v-if="showAssigneeName">
              <span>
                {{ item.assignee.full_name }}
              </span>
            </v-list-item-action>
          </template>

          <!-- children items -->
          <v-list-item v-for="(child) in item.sub_tasks" :key="child.id">
            <v-checkbox
              v-model="child.completed"
              @click.stop="handleCheckbox(child)"
              :disabled="
                !isLoading &&
                  item &&
                  item.sub_tasks &&
                  child.creator &&
                  !(currentUser.id == child.assignee.id) &&
                  !(currentUser.id == child.creator.id) &&
                  !(item.creator.id == currentUser.id) &&
                  !currentUser.privileges.canCompleteAllTasks
              "
            ></v-checkbox>

            <v-list-item-content>
              <v-list-item-title class="wrap-text">
                {{ child.title }}
              </v-list-item-title>

              <v-list-item-subtitle class="wrap-text">
                <v-icon small>
                  mdi-calendar
                </v-icon>
                <span
                  :class="
                    checkIsBefore(child.due_datetime)
                      ? 'red--text font-weight-medium'
                      : 'green--text font-weight-medium'
                  "
                >
                  {{ moment(child.due_datetime).format("DD MMM hh:mm a") }}
                </span>
                <div
                  v-for="tag in child.task_tags"
                  :key="tag.id"	
                  class="d-inline-block"
                >
                  <span
                    :style="
                      `color: ${tag.color}; font-weight: 500; margin-right: 4px`
                    "
                    @click.stop="applyTagFilter(tag)"
                  >
                    {{ tag.name }}
                  </span>
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-tooltip bottom :disabled="showAssigneeName">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-list-item-avatar>
                    <v-img :src="child.assignee.image"></v-img>
                  </v-list-item-avatar>
                </div>
              </template>
              <span>{{ child.assignee.full_name }}</span>
            </v-tooltip>

            <v-list-item-action v-if="showAssigneeName">
              <span>
                {{ child.assignee.full_name }}
              </span>
            </v-list-item-action>
          </v-list-item>
        </v-list-group>
      </div>
    </v-list>

    <TaskDetails
      :visible="showTaskDetailsDialog"
      :showAssigneeName="true"
      :dialogTask="selectedTask"
			:taskIndex="selectedIndex"
			@closeTaskDetailsDialog="closeTaskDetailsDialog"
			@deletedTaskFromDialog="deletedTaskFromDialog"
			@replaceTask="replaceTask"
			@changeTaskInDialog="changeTaskInDialog"
    />

    <v-snackbar
      :timeout="snackbar.timeout"
      v-model="snackbar.visible"
      :color="snackbar.color"
      multi-line
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          v-if="!undoTrigger"
          dark
          text
          v-bind="attrs"
          @click="snackbar.visible = false"
        >
          Close
        </v-btn>
        <v-btn v-else dark text v-bind="attrs" @click="undoOperation">
          Undo
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";
import endpoints from "@api/repository";
// import Helper from "@utils/misc";
import moment from "moment";
import TaskDetails from "@components/task/TaskDetails.vue";
import TourHelper from "@utils/tour_helper";


export default {
  name: "ViewTasks",

  props: {
    items: {
      type: Array,
      default: () => {}
    },
    visible: {
      type: Boolean,
      default: true
    },
    // hides tooltip and shows full name beside avatar(all tasks)
    showAssigneeName: {
      type: Boolean,
      default: false
    },
    hideSnackbar: {
      type: Boolean,
      default: false
    },
    pageCompletionFilter: {
      type: Boolean,
      default: false
    }
  },

  components: {
    TaskDetails
  },

  data() {
    return {
      moment: moment,
      snackbar: {
        visible: false,
        message: "",
        color: "dark",
        timeout: 5000
      },
			currentItem: null,
      showTaskDetailsDialog: false,
      selectedTask: null,
			selectedIndex: null,
      undoTrigger: false
    };
  },

  computed: {
    ...mapGetters([
      "currentUser",
      "accessToken",
      "isLoading",
      "currentInstitution"
    ]),

    apiEssentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors
      };
    }
  },

  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
      var steps = [];
      steps.push({id: '1', description: "Click this checkbox to change the completion status." ,el: '.task-details-checkbox'});
      steps.push({id: '2', description: "Check out the assignee information." ,el: '#assignee-full-name'});
      steps.push({id: '3', description: "Shows subtasks with related information." ,el: '#subtask-container'});
      steps.push({id: '4', el:"#add-subtask-btn", description: "Click to add new Subtask"});
      TourHelper.startTour(this, "view__tasks", steps);
    },

    // handle api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      console.log(err);
      if (err.response) {
        this.snackbar.message = "Unable to process request";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
      }
    },

    async handleCheckbox(item) {
			this.currentItem = item;
			this.undoTrigger = true;
			this.snackbar.message = `Task has been ${
				item.completed ? "completed" : "incompleted"
			}`;
			this.snackbar.color = "success";
			this.snackbar.timeout = 5000;
			this.snackbar.visible = true;

			if(!item.is_sub_task){
				this.changeTaskCompletionStatus(item.id, item.completed);
			}else{
				if(item.completed){
					this.changeTaskCompletionStatus(item.id, item.completed);
				}else{
					var parent_task = this.items.find(t => t.id == item.parent)
					if(!parent_task.completed){
						this.changeTaskCompletionStatus(item.id, item.completed)
					}else{
						var newItem = await this.changeTaskCompletionStatus(item.id, item.completed)

            // emit to parent to replace the task with updated version
						this.$emit('replaceTask', newItem)
					}
				}
			}
    },
		
		async changeTaskCompletionStatus(id, completed){
			var url = endpoints.tasks + `${id}/`
			var response = await api.call(this.apiEssentials, url, api.Methods.PATCH, { "completed": completed })
			if(response){
				return response
			}
		},

    async undoOperation() {
			this.currentItem.completed = !this.currentItem.completed;
			this.changeTaskCompletionStatus(this.currentItem.id, this.currentItem.completed)
      this.snackbar.visible = false;
    },

		deletedTaskFromDialog(id, is_sub_task, parent){
			this.$emit('deletedTaskFromDialog', id, is_sub_task, parent);
		},

		replaceTask(newItem){
			this.$emit('replaceTask', newItem);
		},

    // emit to parent to apply clicked tag in filter
    applyTagFilter(tag) {
      this.$emit("applyTagFilter", tag.id);
    },

    // show task details dialog and store current task
    triggerTaskDetails(task, index) {
      this.showTaskDetailsDialog = true;
      this.selectedTask = task
			this.selectedIndex = index
    },

    // emit to notify parent page/component to change task items after delete action
    deletedTaskStatus(id, is_sub_task) {
      this.$emit("deletedTask", id, is_sub_task);
    },

		changeTaskInDialog(id){
			// notify parent to update task details in dialog
			this.$emit('changeTaskInDialog', id);
		},

    // eslint-disable-next-line no-unused-vars
    closeTaskDetailsDialog() {
      this.showTaskDetailsDialog = false;
    },

    checkIsBefore(date) {
      var dueDate = moment(date);
      var currentDate = moment();
      return dueDate.isBefore(currentDate);
    }
  },

  watch: {
    hideSnackbar: {
      async handler() {
        this.snackbar.visible = false;
      }
    },
		items: {
			async handler() {
				this.selectedTask = this.items[this.selectedIndex]

        var count = this.items.filter(task => task.completed == this.pageCompletionFilter)

        // send parent the count of items currently present 
        this.$emit('listCount', count.length) 
			},
      deep: true
		}
  },

  created() {}
};
</script>

<style scoped>
.v-list-item {
  justify-content: space-between;
}
.wrap-text {
  -webkit-line-clamp: unset !important;
  white-space: normal;
}
.tooltip {
  display: block;
  white-space: normal;
  word-wrap: break-word;
  text-overflow: ellipsis;
}
</style>